import { Check, FileText, Folder, Loader2, X } from "lucide-react";

interface Props {
  filename: string;
  isPending?: boolean;
  isUploaded?: boolean;
  isFolder?: boolean;
  onRemove?: () => void;
}

const truncateName = (name: string, max = 20): string => {
  if (name.length <= max) return name;
  const ext = name.lastIndexOf(".");
  if (ext > 0 && name.length - ext <= 5) {
    const suffix = name.slice(ext);
    return name.slice(0, max - suffix.length - 1) + "\u2026" + suffix;
  }
  return name.slice(0, max - 1) + "\u2026";
};

export const FileAttachmentChip = ({
  filename,
  isPending,
  isUploaded,
  isFolder,
  onRemove,
}: Props) => {
  const displayName = truncateName(filename);

  if (isPending) {
    return (
      <div className="flex items-center gap-2 rounded-[3px] border border-blue-200 bg-blue-50 px-2 py-1 text-xs text-blue-700">
        <Loader2 className="h-3 w-3 animate-spin" />
        <span>Uploading {displayName}</span>
      </div>
    );
  }

  const Icon = isFolder ? Folder : FileText;

  return (
    <div className="flex items-center gap-1.5 rounded-[3px] border border-zinc-200 bg-zinc-50 px-2 py-1 text-xs text-zinc-700">
      <Icon className="h-3.5 w-3.5 text-zinc-400 shrink-0" />
      <span className="max-w-[180px] truncate">{displayName}</span>
      {isUploaded && !isFolder && <Check className="h-3 w-3 text-emerald-500 shrink-0" />}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Remove ${filename}`}
          title="Remove"
          className="text-zinc-400 hover:text-red-700 p-0.5"
        >
          <X className="w-3 h-3" aria-hidden />
        </button>
      )}
    </div>
  );
};
